/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-return */
type Paths<T, D extends number = 5> = [D] extends [never]
  ? never
  : T extends object
    ? {
        [K in keyof T]-?: K extends number | string
          ? `${K}` | (T[K] extends object ? `${K}.${Paths<T[K], Prev[D]>}` : never)
          : never;
      }[keyof T]
    : "";

type Prev = [never, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

type StringKeys<T> = Extract<keyof T, string>;

type ValueAtPath<T, Path extends string> = Path extends keyof T
  ? T[Path]
  : Path extends `${infer Key}.${infer Rest}`
    ? Key extends keyof T
      ? Rest extends Paths<T[Key]>
        ? ValueAtPath<T[Key], Rest>
        : never
      : never
    : never;

const getNestedValue = <T, P extends Paths<T>>(obj: T, path: P): undefined | ValueAtPath<T, P> => {
  const segments = path.split(".") as StringKeys<T>[];

  const reducer = (current: any, segment: StringKeys<T>): any => {
    return current && typeof current === "object" && segment in current ? current[segment] : undefined;
  };
  return segments.reduce(reducer, obj) as undefined | ValueAtPath<T, P>;
};

const replacePlaceholders = (text: string, replacements: Record<string, number | string>): string => {
  return Object.entries(replacements).reduce(
    (acc, [key, value]) => acc.replace(new RegExp(`{{${key}}}`, "g"), String(value)),
    text,
  );
};

export const i18nLike =
  <T>(locale: T) =>
  <Path extends Paths<T>, R extends Record<string, number | string> | undefined = undefined>(
    key: Path,
    replacements?: R,
  ): R extends undefined ? (ValueAtPath<T, Path> extends string ? ValueAtPath<T, Path> : string) : string => {
    const rawValue = getNestedValue(locale, key);

    if (rawValue === undefined) {
      return `Missing key: ${String(key)}` as any;
    }

    if (typeof rawValue !== "string") {
      return String(rawValue) as any;
    }

    if (!replacements) {
      return rawValue as any;
    }

    return replacePlaceholders(rawValue, replacements) as any;
  };
